import { type ActionItem } from 'shared/ui'
import { Team, type TeamRow } from 'entities/Teams'
import { type TeamsStore } from 'pages/settings/pages/teams/store/TeamsStore'

export const getTeamsTableActions = (item: TeamRow, teamsStore: TeamsStore): ActionItem[] => {
  const { openDeleteModal, handleRequestRenameTeam, handleResyncIntegrationTeam } = teamsStore
  const teamId = item.origin.id
  const actions: ActionItem[] = [
    {
      icon: 'delete',
      text: 'Delete',
      onAction: () => openDeleteModal(item.id, item.isIntegrationTeam),
    },
  ]

  if (item.isIntegrationTeam && item.integrationTeam) {
    actions.unshift({
      icon: 'refresh',
      text: 'Refresh data',
      onAction: () => handleResyncIntegrationTeam(teamId),
    })
  }

  if (!item.isIntegrationTeam) {
    actions.unshift({
      icon: 'edit',
      text: 'Rename',
      onAction: () => handleRequestRenameTeam(new Team(item.origin)),
    })
  }

  return actions
}
